module.exports = __webpack_public_path__ + "i18n/es_4240335c6949c67980fce071c81cccaf.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_es.properties
// module id = DOE4
// module chunks = 51